/* eslint-disable camelcase */
import PropTypes from 'prop-types';

export const coursePropType = PropTypes.shape({
    author: PropTypes.string,
    closed: PropTypes.bool,
    color: PropTypes.string,
    cover: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    date_updated: PropTypes.number,
    description: PropTypes.string,
    free: PropTypes.bool,
    id: PropTypes.number,
    mode: PropTypes.number,
    name: PropTypes.string,
    subject: PropTypes.string,
});
